<template>
    <div style="border: 0;padding: 0">
        <input
                type="text"
                :class="['form-control', 'numeric-input']"
                :value="formattedValue"
                :placeholder="placeholder"
                :max="max"
                :min="min"
                :style="{'textAlign': this.align}"
                @keypress="onKeyPress"
                @input="onInput"
                @change="onChange"
                @blur="onBlur"
                @focus="onFocus"
                :autofocus="autofocus"
                :disabled="disabled"
                :readonly="readonly"/>
    </div>
</template>

<script>
    import currency from '@/shared/filters/currency';

    export default {
        name: "NumericInput",
        props: {
            placeholder: String,
            value: [Number, String],
            min: {
                type: Number,
                default: -Infinity
            },
            max: {
                type: Number,
                default: Infinity
            },
            align: {
                type: String,
                default: 'left'
            },
            autofocus: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            precision: {
                type: Number,
                default: 0
            },
            decimalSeparator: {
                type: String,
                default: '.'
            },
            thousandsSeparator: {
                type: String,
                default: ' '
            },
            allowNegative: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                focused: false,
                formattedValue: null,
                digits: ['1','2','3','4','5','6','7','8','9','0']
            }
        },
        methods: {
            parseValue(event) {
                let value;
                if (event.target.value && event.target.value.length > 0) {
                    value = parseFloat(event.target.value.replace(new RegExp(this.thousandsSeparator, 'g'), ''));
                } else {
                    value = null;
                }
                return value;
            },
            onKeyPress(event) {
                const cursorPos = this.getCursorPosition(event.target);
                if (this.digits.includes(event.key) || (this.precision > 0 && event.key === this.decimalSeparator) || (this.allowNegative && cursorPos===0 && event.key === '-')) {
                    const value = event.target.value;
                    if (value && value.length > 0) {
                        if (value.includes(this.decimalSeparator)) {
                            if (event.key === this.decimalSeparator) {
                                event.preventDefault();
                            } else {
                                if (this.precision > 0) {
                                    const decimalSeparatorIndex = value.indexOf(this.decimalSeparator);
                                    if (decimalSeparatorIndex >= 0 && cursorPos > decimalSeparatorIndex) {
                                        const decimalValue = value.substring(decimalSeparatorIndex + 1);
                                        if (decimalValue && decimalValue.length >= this.precision) {
                                            event.preventDefault();
                                        }
                                        // const cursorPos = this.getCursorPosition(event.target);
                                        // if (cursorPos > decimalSeparatorIndex + this.precision) {
                                        //     event.preventDefault();
                                        // }
                                    }
                                }
                            }
                        }
                    }
                } else {
                    event.preventDefault();
                }
                // console.log('keypress', event);
            },
            onInput(event) {
                let value = this.parseValue(event);
                if (this.max > 0 && value > this.max) {
                    value = this.max;
                } else if (value < this.min) {
                    value = this.min;
                }
                if ((this.value === null && value !== null) || (this.value !== null && value === null) || this.value !== value) {
                    // this.numericValue = value;
                    this.$emit('input', value);
                }
                // console.log('input', event);
            },

            onChange(/*event*/) {
                this.$emit('change', this.value);
                // console.log('change', event.target.value);
            },
            onBlur(event) {
                this.focused = false;
                if (this.value) {
                    event.target.value = currency(this.value, '', this.precision, {thousandsSeparator: this.thousandsSeparator});
                } else {
                    event.target.value = '';
                }
                // console.log('blur', event);
            },
            onFocus(event) {
                this.focused = true;
                if (event.target.value && event.target.value.length > 0) {
                    event.target.value = this.parseValue(event);
                }
                // console.log('cursor_pos', this.getCursorPosition(event.target));
                // console.log('focus', event);
            },
            /*
            ** Returns the caret (cursor) position of the specified text field.
            ** Return value range is 0-oField.value.length.
            */
            getCursorPosition(target) {
                let cursorPosition = 0;
                if (document && document.selection) { // IE Support
                    // Set focus on the element
                    target.focus();
                    // To get cursor position, get empty selection range
                    const selRange = document.selection.createRange();
                    // Move selection start to 0 position
                    // selRange.moveStart('character', -target.value.length);
                    // The caret position is selection length
                    cursorPosition = selRange.text.length;
                } else if (target.selectionStart || target.selectionStart === '0') { // Firefox support
                    cursorPosition = target.selectionStart;
                }
                // Return results
                return cursorPosition;
            }
        },
        // watch: {
        //     value(newVal, /*oldVal*/) {
        //         if (!this.focused) {
        //             if (newVal) {
        //                 this.formattedValue = currency(newVal, '', this.precision, {thousandsSeparator: this.thousandsSeparator});
        //             } else {
        //                 this.formattedValue = '';
        //             }
        //         }
        //         console.log('new_val', newVal);
        //         console.log('old_val', oldVal);
        //     }
        // }
        watch: {
            // Watch for value change
            value: {
                immediate: true,
                // handle the changed value
                handler(val) {
                    if (!this.focused) {
                        if (val) {
                            this.formattedValue = currency(val, '', this.precision, {thousandsSeparator: this.thousandsSeparator});
                        } else {
                            this.formattedValue = '';
                        }
                    }
                    // console.log('watch_val', val);
                }
            }
        }
    }
</script>

<style scoped>

</style>